import { observer } from "mobx-react-lite";
import IconTuner from "@asphalt-react/icontuner";
import { Cross } from "@asphalt-react/iconpack";
import { Text } from "src/components/Text";
import { Box } from "src/components/Box";
import * as React from "react";
import styled, { css } from "styled-components";
import { useFilePickerState } from "../states";
import { MediaQueries } from "src/constants";
import { useTranslation } from "src/hooks";
import { Button } from "../../../Button";

const FakeButtonWrapperEl = styled(Box)`
  flex-direction: column;
  z-index: 1;

  ${MediaQueries.screen.medium.minWidth} {
    flex-direction: row;
    ${(props) =>
      props &&
      css`
        &:first-child {
          margin-left: ${props.theme.layout.margin.s}px;
        }

        &:last-child {
          margin-right: ${props.theme.layout.margin.s}px;
        }
      `}
  }
`;

const ErrorIconEl = styled.div`
  & svg {
    height: 80px;
    width: 80px;
  }
`;

export const FilePickerError = observer(() => {
  const translate = useTranslation();
  const state = useFilePickerState();
  const { errorMessage, retry, deleteFile } = state;

  const onReUploadClick = () => {
    deleteFile();
    setTimeout(() => {
      state.inputRef?.current?.click();
    }, 100);
  };

  return (
    <>
      <ErrorIconEl>
        <IconTuner danger>
          <Cross />
        </IconTuner>
      </ErrorIconEl>
      <Text
        color="danger"
        fontWeight="demi"
        fontSize="xsmall"
        marginBottomM
        marginTopS
        textCenter
      >
        {errorMessage}
      </Text>
      <Box
        flex
        flexDirectionColumn
        width100
        paddingLeftXl
        paddingRightXl
        marginTopM
      >
        <FakeButtonWrapperEl
          flex
          paddingRightL
          paddingLeftL
          width100
          justifyEvenly
        >
          {state.allowRetries && (
            <Button onClick={retry} paddingLeftXl paddingRightXl>
              {translate("error.cta.retry")}
            </Button>
          )}
          <Button onClick={onReUploadClick} paddingLeftXl paddingRightXl>
            {translate("error.cta.reupload")}
          </Button>
        </FakeButtonWrapperEl>
      </Box>
    </>
  );
});
